<template>
  <v-flex class="mrc-grey">
    <v-row
      v-if="getCost() != null"
      align="start"
    >
      <v-flex
        v-if="fixedCostArea() != null"
        shrink
        pt-2
        style="padding-right: 3px"
      >
        <p style="font-size: 9px">
          Fixed Cost Trip &nbsp;
          {{ "ID: " + fixedCostArea().id + " - " + fixedCostArea().name }}
        </p>

        <!--
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="primary"
                      dark
                      v-on="on"
                    >
                      info
                    </v-icon>
                  </template>
                  <p style="font-size: 12px">
                    {{ "Fixed Cost Trip ID: " + fixedCostArea().id + " - " + fixedCostArea().name }}
                  </p>
                </v-tooltip>
        -->
      </v-flex>
      <v-flex
        md12
        pt-2
        shrink
      >
        <v-layout>
          <v-layout wrap >
<!--
            <v-flex md12 lg12 align-self-start>
              <p
                  v-if="bookingForm.booking.final_fare != null"
                  class="cost-amount"
              >
                Fare £{{ bookingForm.booking.final_fare }}
              </p>
            </v-flex>
-->
            <v-flex shrink>
              <p
                v-if="getCost() != null"
                class="cost-amount"
              >
                <span class="cmr-label-text">Est</span>
                <span class="cmr-value-text">
                £{{ (getCost() / 100).toFixed(2) }}
                </span>
              </p>
            </v-flex>
            <v-flex md12
                    v-if="bookingForm.booking.promocode != null && getCostPromotion()"
            >
              <p
                class="cost-amount"
              >
                <span class="cmr-label-text">Promo Code </span>
                <span class="cmr-value-text">
                £{{ calculatePromoCode() }}
                </span>
              </p>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout>
          <v-flex
              v-if="costOfAdditionals() != null && costOfAdditionals() != 0"
          >
            <p class="cost-amount">
              <span class="cmr-label-text">
                Additional
              </span>
              <span class="cmr-value-text">
                £{{ costOfAdditionals() }}
              </span>
            </p>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
              md12
            v-if="finalCostIncludingAdditionals() != null"
            shrink
          >
            <p class="cost-amount">
              <span class="cmr-label-text">Final Cost </span>
              <span class="cmr-value-text">
                              £{{ finalCostIncludingAdditionals() }}
              </span>
            </p>
          </v-flex>
          <v-flex
            v-if="bookingForm.booking.state != null && bookingForm.booking.final_cost > 0 && bookingForm.booking.final_cost != finalCostIncludingAdditionals()"
            shrink
          >
            <p class="cost-amount">
              <span class="cmr-label-text">Old Final Cost</span>
              <span class="cmr-value-text">
              &nbsp;&nbsp; £{{ bookingForm.booking.final_cost }}
              </span>
            </p>
          </v-flex>
          <v-flex>
            <p
              v-if="bookingForm.booking.final_cost_promotion"
              class="cost-amount"
            >
              <span class="cmr-label-text">
              Final Cost Promotion
              </span>

              <span class="cmr-value-text">
                              £{{ (bookingForm.booking.final_cost_promotion.toFixed(2)) }}

              </span>
            </p>
          </v-flex>
          <v-flex
              grow
            v-if="bookingIsCompletedOrCancelled && bookingForm.booking.fixed_commission != null"
          >
            <p class="cost-amount">
              <span class="cmr-label-text">
                Fixed Commission
              </span>
              <span class="cmr-value-text">
              £{{ bookingForm.booking.fixed_commission }}
              </span>
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="bookingForm.booking.finalFareMode == true"
        pt-2
      />
      <v-flex
        v-if="isReturnBooking && showFareWarning"
        class="mt-2"
      >
        <v-chip
          close
          color="red"
          class="white--text"
          @click:close="showFareWarning = false"
        >
          Please note that this fare may not be accurate as its not system generated
        </v-chip>
      </v-flex>
    </v-row>
  </v-flex>
</template>

<script>

import BookingAdditionalChargeSummary from "@/components/widget/input/BookingAdditionalChargeSummary.vue";

export default {
  name: "EstimatedCost",
  components: {
    BookingAdditionalChargeSummary
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    bookingForm: Object,
  },
  data() {
    return {
      showFareWarning: true,
    };
  },
  computed: {
    isReturnBooking () {
      return this.$store.getters['booking/getIsReturnBooking']
    },
    styleForFinalCostBox: function () {
      return {
        "background-color": "#FFB6C1",
      };
    },
  },
  methods: {
    calculatePromoCode () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;
    
        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return ((costForRideType.estimate - costForRideType.estimate_promotion)/100).toFixed(2);
        } else {
          return null;
        }
      }
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    },
    getCostEstimate: function() {
      this.$emit("getCostEstimate")
    },
    getCostObject: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
      
        return costForRideType;
      }
    },
    getCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate;
        } else {
          return null;
        }
      }
    },
    getCostPromotion: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate_promotion;
        } else {
          return null;
        }
      }
    },
    fixedCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.fixed_cost;
        } else {
          return null;
        }
      }
    },
    fixedCostArea: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.fixed_cost_area;
        } else {
          return null;
        }
      }
    },
    finalCostIncludingAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare) + additionalCharges / 100).toFixed(2);
        } else {
          // return (this.getCost()/100 + additionalCharges / 100).toFixed(2);
          return (this.getCost()/100).toFixed(2);
        }

      } else {
        return null;
      }
    },
    costOfAdditionals: function () {
        var additionalCharges = 0;

        for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) { 
          if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
            additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
          } 
        }

        return (additionalCharges / 100).toFixed(2);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.cost-amount {
  font-size: 12px;
  font-weight: 500;
}

.est-text {
  font-size: 12px;
  font-weight: 700;
}

</style>
